import {
    ModuleWithProviders,
    NgModule,
} from '@angular/core';
import {
    PageCategory,
    PageScope,
    providePageMeta,
} from '@app/router';

@NgModule()
export class UserMetaModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: UserMetaModule,
            providers: [
                providePageMeta({
                    title: 'Users',
                    translationKey: 'page_users',
                    routerLink: '/users',
                    sidebarSection: 'Management',
                    icon: 'people',
                    permission: 'Users.View',
                    type: 'Sidebar',
                    category: PageCategory.Tenant,
                    scope: PageScope.Global,
                    priority: 1,
                }),
            ],
        };
    }
}
